import { API, graphqlOperation } from 'aws-amplify';
import {
  getIOTDocument,
  onUpdateIOTDocument,
} from '../../../graphql/iot-documents';
import { store } from '../..';

const abreConexao = async (thing) => {
  const updateIotSubscription = await onUpdateIOTDocument();
  const newConection = await API.graphql(
    graphqlOperation(updateIotSubscription, { thingName: thing.thing })
  ).subscribe({
    next: (subscribeData) => {
      if (
        subscribeData.value &&
        subscribeData.value.data &&
        subscribeData.value.data.onUpdateIOT
      ) {
        let valorAtual = {};
        const realtimeRedux = store.getState().dashboard.realtimeData;
        let total = realtimeRedux;
        total = {
          onTime: subscribeData.value.data.onUpdateIOT.PotenciaAtivaMedia,
          potencia: subscribeData.value.data.onUpdateIOT.PotenciaAtivaMedia,
          vazao:
            realtimeRedux.vazao -
            (valorAtual.vazao || 0) +
            subscribeData.value.data.onUpdateIOT.Vazao,
        };

        store.dispatch({
          type: 'OPERACIONAL/SET_REALTIME',
          data: total,
        });
        store.dispatch({
          type: 'OPERACIONAL/SET_VALORES_UCHAS_EBAS',
          uchas: { onTime: total.onTime },
          ebas: { potencia: total.potencia, vazao: total.vazao },
        });
        valorAtual = {
          ...valorAtual,
          potencia: subscribeData.value.data.onUpdateIOT.PotenciaAtivaMedia,
        };
      }
    },
    error: () => {
      newConection.unsubscribe();
    },
  });
  return newConection;
};

export async function conectaThing(thing) {
  const conexoesAbertas = store.getState().primeiroNivel.unsubscribe;
  if (conexoesAbertas) conexoesAbertas();

  const iotQuery = await getIOTDocument();
  API.graphql(graphqlOperation(iotQuery, { thingName: thing.thing })).then(
    async (resp) => {
      const data = 'getIOT' in resp ? resp.getIOT || {} : resp.data.getIOT;
      const conexao = await abreConexao(thing);
      const valueThing = {
        onTime: data?.PotenciaAtivaMedia,
        vazao: data?.Vazao,
        potencia: data?.PotenciaAtivaMedia,
      };
      store.dispatch({
        type: 'OPERACIONAL/SET_VALORES_UCHAS_EBAS',
        uchas: { onTime: valueThing.onTime },
        ebas: { potencia: valueThing.potencia, vazao: valueThing.vazao },
        unsubscribe: () => conexao.unsubscribe(),
      });
    }
  );
}
